import type { ShiftBlock } from "@/lib/types";

type Props = {
  shift: ShiftBlock;
  selected: boolean;
  disabled?: boolean;
  onToggle: () => void;
};

export function ShiftCard({ shift, selected, disabled, onToggle }: Props) {
  const base =
    "relative flex flex-col items-center justify-center rounded-2xl border-2 p-4 transition-all duration-200 active:scale-95";
  const stateClasses = selected
    ? "border-pink-600 bg-gradient-to-br from-pink-500 to-rose-500 text-white shadow-lg shadow-pink-200/50"
    : "border-pink-100 bg-white text-gray-800 shadow-sm";
  const disabledClasses = disabled
    ? "cursor-not-allowed opacity-50"
    : "cursor-pointer hover:shadow-md";

  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={selected}
      className={`${base} ${stateClasses} ${disabledClasses}`}
    >
      {selected && (
        <span className="absolute right-2 top-2 text-xs text-white" aria-hidden>
          ✓
        </span>
      )}
      <span className="text-sm font-black leading-tight">{shift.label}</span>
      <span
        className={`mt-0.5 text-xs ${
          selected ? "text-pink-100" : "text-gray-400"
        }`}
      >
        {shift.hours} giờ
      </span>
    </button>
  );
}
